import "~/misc/common";
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    $('.cr-copy').on('click', function () {
      navigator.clipboard.writeText($(this).data('value'));
      $(this).blur();
      $(this).removeClass('btn-default');
      $(this).addClass('btn-success');
      if ($(this).data('url')) {
        window.open($(this).data('url'), '_blank');
      }
    });
  }
}